var module = angular.module('octopusApp.library');

module.controller('VariableSetsIndexController', function($scope, $location, busy, octopusRepository) {
  var isLoading = $scope.isLoading = busy.create();
  isLoading.promise(octopusRepository.LibraryVariableSets.list({contentType: 'Variables'}).then(function (variableSets) {
    $scope.variableSets = variableSets;
  }));
});




//////////////////
// WEBPACK FOOTER
// ./app/areas/library/variables/controllers/variablesets_index_controller.js
// module id = 474
// module chunks = 1